import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    root: {
      display: 'grid',
      gridTemplateRows: '1fr auto',
      width: '100%',
    },
    listContainer: {
      padding: theme.spacing(0.5, 2),
      overflowY: 'auto',
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing(0, 2),
      borderTop: `solid 1px ${theme.palette.divider}`,
    },
    groupList: {
      paddingLeft: theme.spacing(3.5),
    },
    toggleComponent: {
      padding: theme.spacing(1),
    },
  };
};
